import type { BaseBigNumber } from '../abstracts';

export * from './pos_erc1155_deposit_param';
export * from './pos_erc1155_transfer_param';

export type TYPE_AMOUNT = BaseBigNumber | string | number;
